// imports
// schema
import * as ISchema from "@schema";

import { commitMutation } from "react-relay";
import { Environment } from "relay-runtime";
import { batchModifyAutopilotForEventsMutation } from "./ModifyAutopilotForEvent.gql";
import { modernCache } from "@network/modern-network-layer";

// types
// interface IModifyAutopilotForEventResponse {
//   modifyAutopilotForEvent: ISchema.IModifyAutopilotForEventMutationPayload;
// }

interface IBatchModifyAutopilotForEventsResponse {
  batchModifyAutopilotForEvents: ISchema.IBatchModifyAutopilotForEventsMutationPayload;
}

// mutations

// export function modifyAutopilotForEvent(
//   environment: Environment,
//   input: ISchema.IModifyAutopilotForEventMutationInput,
//   onSuccess: (response?: ISchema.IModifyAutopilotForEventMutationPayload) => void,
//   onError: (error?: any) => void,
// ) {
//   commitMutation(
//     environment,
//     {
//       onError,
//       mutation: modifyAutopilotForEventMutation,
//       variables: { input },
//       onCompleted: (response: IModifyAutopilotForEventResponse, errors?: Error[]) => {
//         if (!!errors) {
//           onError(errors[0]);
//         } else {
//           // if we're not in a modern environment, modernCache will be undefined
//           if (modernCache) {
//             modernCache.clear();
//           }
//           onSuccess(response.modifyAutopilotForEvent);
//         }
//       },
//     },
//   );
// }

export function batchModifyAutopilotForEvents(
  environment: Environment,
  input: ISchema.IBatchModifyAutopilotForEventsMutationInput,
  onSuccess: (response?: ISchema.IBatchModifyAutopilotForEventsMutationPayload) => void,
  onError: (error?: any) => void,
) {
  commitMutation(environment, {
    onError,
    mutation: batchModifyAutopilotForEventsMutation,
    variables: { input },
    onCompleted: (response: IBatchModifyAutopilotForEventsResponse, errors?: Error[]) => {
      if (!!errors) {
        onError(errors[0]);
      } else {
        // if we're not in a modern environment, modernCache will be undefined
        if (modernCache) {
          modernCache.clear();
        }
        onSuccess(response.batchModifyAutopilotForEvents);
      }
    },
  });
}
